import { QueryHookOptions, useQuery } from '@apollo/client';
import { GetPreferredProviders } from './queries';
import { preferredProviders } from './__generated__/preferredProviders';

export function usePreferredProvidersQuery(
  options?: QueryHookOptions<preferredProviders>
) {
  return useQuery<preferredProviders>(GetPreferredProviders, options);
}
